import cx from 'classnames';
import * as React from 'react';

import Button from 'components/Button';
import Buttons from 'components/Buttons';
import { IconColor, IconName } from 'components/Icon';
import TextWithIcon from 'components/TextWithIcon';
// @ts-ignore
import View from 'components/View';
import WizardHeader from 'components/WizardHeader';
import { MouseEventHandler } from 'types/typescript/eventHandlers';

import './WizardLayout.scss';

type Props = {
  children?: React.ReactNode;
  className?: string;
  headerIcon: IconName;
  headerIconColor: IconColor;
  nav?: React.ReactNode;
  onBack: MouseEventHandler;
  sidebar?: React.ReactNode;
  title: string;
  wrapInView?: boolean;
};

export default function WizardLayout({
  onBack,
  children,
  className,
  headerIcon,
  headerIconColor,
  nav,
  sidebar,
  title,
  wrapInView = true,
}: Props) {
  return (
    <div className={cx('WizardLayout', className)}>
      <WizardHeader>
        <TextWithIcon icon={headerIcon} iconColor={headerIconColor} iconSize="large" size="large">
          {title}
        </TextWithIcon>
        <Buttons>
          {nav}
          <Button color="polar-bear" level="secondary" size="xsmall" onClick={onBack}>
            Close
          </Button>
        </Buttons>
      </WizardHeader>
      <div className="WizardLayout-inner">
        {sidebar && <div className="WizardLayout-sidebar">{sidebar}</div>}
        <div className="WizardLayout-content">
          {wrapInView ? <View>{children}</View> : children}
        </div>
      </div>
    </div>
  );
}
